<template>
  <div
    class="bg"
    v-loading="loading"
    element-loading-text="加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <div class="title" v-show="unlogin">代账公司办公系统</div>
    <div class="box" v-show="unlogin">
      <div class="pannel">
        <el-form class="login-form" ref="loginForm" :rules="rules" label-width="0px" :model="userInfo">
          <div class="sub-title">您好，欢迎体验</div>
          <div style="display: flex;">
            <div style="flex:1">
              <el-form-item prop="yzm">
                <el-input v-model="userInfo.yzm" placeholder="请输入验证码" @keyup.enter.native="qrcode"></el-input>
              </el-form-item>
            </div>
            <div style="margin-left:auto;width:96px">
              <img :src="pic" @click="getCodeToken" :style="{ width: '90px', height: '40px' }" />
            </div>
          </div>
          <el-button type="primary" size="small" class="submit-btn" @click="qrcode">登录</el-button>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios' // md5加密
export default {
  name: 'welcome',
  data() {
    return {
      userInfo: {
        yzm: ''
      },
      params: {},
      code: '',
      id: '',
      pic: '',
      codeToken: '',
      loading: false,
      unlogin: false,
      // 表单验证
      rules: {
        userName: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
        pwd: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        sfzmhm: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (!value) {
                callback(rule.msg)
              } else if (!this.$fgId18Validate(value)) {
                callback('身份证明号码格式错误！')
              } else {
                callback()
              }
            },
            msg: '请输入身份证明号码',
            trigger: 'blur'
          }
        ],
        yzm: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (!value) {
                callback(rule.msg)
              } else if (value.length !== 4) {
                callback('验证码错误！')
              } else {
                callback()
              }
            },
            msg: '请输入验证码',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  mounted() {
    this.params = this.getUrlParam(window.location.href)
    this.wechatExperientialLogin()
    // this.$root.$children[0].sign('http://17l.link/dist/?id=1&targetName=experience&wechatLogin=true&state=123')
  },
  methods: {
    // 解析页面URL
    getUrlParam(url) {
      var paramStr = url.substring(url.indexOf('?') + 1, url.length).split('&')
      var j
      var paramObj = {}
      for (var i = 0; (j = paramStr[i]); i++) {
        console.log(i)
        paramObj[j.substring(0, j.indexOf('='))] = j.substring(j.indexOf('=') + 1, j.length)
      }
      var returnValue = paramObj
      if (typeof returnValue === 'undefined') {
        return ''
      } else {
        return returnValue
      }
    },
    // 二维码请求
    getCodeToken() {
      const params = {}
      this.loading = true
      this.$get('/login/getCodeToken', params)
        .then(response => {
          this.loading = false
          this.codeToken = response.data.codetoken
          if (response.status === 200) {
            axios
              .get(this.$baseURL + '/login/getCodePic?codeToken=' + response.data.codetoken, {
                responseType: 'arraybuffer'
              })
              .then(response => {
                return (
                  'data:image/png;base64,' +
                  btoa(new Uint8Array(response.data).reduce((data, byte) => data + String.fromCharCode(byte), ''))
                )
              })
              .then(result => {
                this.pic = result
              })
          } else {
            this.$root.$children[0].vueAlert({ message: response.status + ':' + response.msg, type: 'error' })
          }
        })
        .catch(err => {
          console.log(err)
          this.loading = false
          this.$root.$children[0].vueAlert({ message: '请求失败，请联系管理员！', type: 'error' })
        })
    },
    // 登录获取二维码点击
    qrcode() {
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          this.wechatExperientialLogin()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 微信登录
    wechatExperientialLogin() {
      const param = {
        loginname: 'A123456',
        password: '888888',
        code: this.$route.params.code,
        verificationCode: this.userInfo.yzm || '',
        codeToken: this.codeToken || ''
      }
      this.loading = true
      // this.$get('login/wechatLogin', param).then(
      this.$post('/login/doLogin', param).then(
        result => {
          this.loading = false
          if (result.status === 200) {
            this.$common.session.set('userInfo', result.data)
            this.$common.session.set('token', result.data.token)
            console.log(this.$route.params)
            this.$router.push({
              name: 'Customer',
              params: {
                id: this.$route.params.id,
                code: this.$route.params.code
              }
            })
          } else {
            this.$dialog
              .alert({
                message: result.msg
              })
              .then(() => {
                this.unlogin = true
                this.getCodeToken()
                // eslint-disable-next-line no-undef
              })
          }
        },
        error => {
          this.loading = false
          this.$dialog.alert({
            message: error.name + ':' + error.message
          })
        }
      )
    }
  },
  destroyed() {}
}
</script>

<style lang="less">
.text-center {
  text-align: center;
}
.el-input__prefix {
  height: 5vh;
}
.pannel .el-input--prefix .el-input__inner {
  padding-left: 6vh;
}
.pannel .el-form-item__content {
  height: 40px;
}
</style>
<style lang="less" scoped>
.bg {
  background: #1e1e1e;
  background-size: cover;
  height: auto;
  min-height: 100vh;
  width: 100%;
  .title {
    margin: 0 auto;
    padding: 4.5vh 0 0 0;
    padding-left: (12/1.6) + vw;
    width: 78.6vw;
    color: #fff;
    font-size: 2.2rem;
    font-family: '黑体';
    font-weight: bold;
    text-align: center;
  }
  // 表单标题
  .sub-title {
    margin-bottom: 8vh;
    font-size: 2rem;
    font-weight: bold;
    text-align: center;
    color: #fff;
  }
  // 表单框
  .box {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    z-index: 100;
    margin: 0 auto;
    width: 78.6vw;
    height: 49.1vw;
    min-height: 510px;
    .pannel {
      display: flex;
      justify-content: center;
      box-sizing: border-box;
      margin: 2vh 2vw 10vh;
      width: 100%;
      .login-form {
        margin: 0 auto;
        width: 250px;
        .login-icon {
          margin: 1vh;
          height: 2.15rem;
          font-size: 2.15rem;
        }
      }
      .submit-btn {
        margin: 10px auto;
        width: 100%;
        height: 40px;
        border: none;
        background: linear-gradient(90deg, #333 0%, #444 100%);
        border-radius: 1vh;
        font-size: 1.5rem;
        line-height: 5px;
      }
    }
  }
  .footer {
    width: 100%;
    position: fixed;
    bottom: 3vh;
    color: #fff;
    font-size: 13px;
    font-weight: bold;
    a {
      color: #409eff;
    }
    a:hover {
      text-decoration: underline;
    }
  }
}
</style>
